/* Bob Logistics — Shop feed: category pills + infinite product grid */
(function () {
  if (window.__giftgoShopfeedInit) return;
  window.__giftgoShopfeedInit = true;

  var WKEY = 'giftgo:wishlist';
  function wishlist() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function saveWishlist(a) { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} }
  function money(v) { var n = Math.round(parseFloat(v) || 0); return '₦' + n.toLocaleString('en-NG'); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  var BAG = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6.2 8h11.6l-.9 11a1.2 1.2 0 0 1-1.2 1.1H8.3A1.2 1.2 0 0 1 7.1 19L6.2 8z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M9 8.5V6.8a3 3 0 0 1 6 0v1.7" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
  var HEART = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 21s-7.5-4.9-10-9.2C.6 9 1.6 5.5 4.8 4.8 7 4.3 9 5.6 12 8.5c3-2.9 5-4.2 7.2-3.7C22.4 5.5 23.4 9 22 11.8 19.5 16.1 12 21 12 21z"/></svg>';
    function speedFor(tags) {
    var s = '';
    (tags || []).forEach(function (t) { if (t.indexOf('speed:') === 0) s = t.slice(6); });
    return s;
  }
  function badgeFor(tags) {
    var s = '';
    (tags || []).forEach(function (t) { if (t.indexOf('speed:') === 0) s = t.slice(6); });
    switch (s) {
      case '30-min': return '30 MIN';
      case 'same-day': return 'SAME DAY';
      case 'express': return '1-2 DAY';
      case '3-5-days': return '3-5 DAYS';
      case '2-3-days': return '2-3 DAYS';
      case '2-4-days': return '2-4 DAYS';
      case '2-5-days': return '2-5 DAYS';
      case '2-7-days': return '2-7 DAYS';
      case '4-7-days': return '4-7 DAYS';
      case '3-7-days': return '3-7 DAYS';
      case '5-7-days': return '5-7 DAYS';
      case '5-10-days': return '5-10 DAYS';
      case '7-15-days': return '7-15 DAYS';
      case '15-20-days': return '15-20 DAYS';
      default: return '1 TO 3 DAY';
    }
  }

  class GiftgoShopfeed extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-gfeed-grid]');
      this.status = this.querySelector('[data-gfeed-status]');
      this.sentinel = this.querySelector('[data-gfeed-sentinel]');
      this.pills = Array.prototype.slice.call(this.querySelectorAll('.gfeed__pill'));
      this.limit = parseInt(this.getAttribute('data-limit'), 10) || 24;
      this.base = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      this.handle = 'all';
      this.catLabel = '';
      this.page = 1;
      this.loading = false;
      this.done = false;

      var self = this;
      this.pills.forEach(function (p) { p.addEventListener('click', function () { self.selectPill(p); }); });

      this.grid.addEventListener('click', function (e) {
        var bag = e.target.closest && e.target.closest('.gfeed-card__bag');
        if (bag) { e.preventDefault(); self.addToCart(bag); return; }
        var heart = e.target.closest && e.target.closest('.gfeed-card__heart');
        if (heart) { e.preventDefault(); self.toggleHeart(heart); return; }
      });

      this._onScroll = function () { self.maybeLoad(); };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) self.maybeLoad(); });
        }, { rootMargin: '800px 0px' });
        this.io.observe(this.sentinel);
      }
      this.maybeLoad();
    }

    maybeLoad() {
      if (this.loading || this.done) return;
      var r = this.sentinel.getBoundingClientRect();
      if (r.top <= (window.innerHeight || 0) + 300) this.loadNext();
    }

    selectPill(p) {
      if (p.classList.contains('is-active')) return;
      this.pills.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
      p.classList.add('is-active');
      p.setAttribute('aria-selected', 'true');
      this.handle = p.getAttribute('data-handle');
      var lbl = p.querySelector('.gfeed__pill-label');
      this.catLabel = (this.handle === 'all') ? '' : (lbl ? lbl.textContent : '');
      this.grid.innerHTML = '';
      this.page = 1;
      this.done = false;
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.maybeLoad();
    }

    url() {
      var h = (this.handle === 'all') ? 'collections/all' : ('collections/' + encodeURIComponent(this.handle));
      return this.base + h + '/products.json?limit=' + this.limit + '&page=' + this.page;
    }

    loadNext() {
      if (this.loading || this.done) return;
      this.loading = true;
      this.status.hidden = false;
      this.status.innerHTML = '<span class="gfeed__spinner" role="status" aria-label="Loading"></span>';
      var self = this;
      fetch(this.url())
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var ps = (d && d.products) || [];
          var frag = document.createDocumentFragment();
          var liked = wishlist();
          ps.forEach(function (p) { var el = self.card(p, liked); if (el) frag.appendChild(el); });
          self.grid.appendChild(frag);
          if (ps.length < self.limit) self.done = true;
          self.page++;
          self.loading = false;
          if (self.done) {
            self.status.hidden = self.grid.children.length > 0;
            self.status.textContent = self.grid.children.length > 0 ? '' : 'No products yet.';
          } else {
            self.status.hidden = true;
            // If the sentinel is still on-screen after layout settles (viewport taller than
            // the batch), pull one more; otherwise wait for the user to scroll.
            requestAnimationFrame(function () { self.maybeLoad(); });
          }
        })
        .catch(function () {
          self.loading = false;
          self.status.hidden = false;
          self.status.textContent = 'Could not load more products.';
        });
    }

    card(p, liked) {
      var vs = p.variants || [];
      var v = null;
      for (var i = 0; i < vs.length; i++) { if (vs[i].available) { v = vs[i]; break; } }
      if (!v) v = vs[0];
      if (!v) return null;

      var img = (p.images && p.images[0] && p.images[0].src) || '';
      if (img) img = img.split('?')[0] + '?width=500';
      var cat = (p.product_type || this.catLabel || '').trim();
      var liked1 = liked.indexOf(p.handle) > -1;
      var purl = this.base + 'products/' + p.handle;

      var el = document.createElement('div');
      el.className = 'gfeed-card';
      el.innerHTML =
        '<a class="gfeed-card__media" href="' + purl + '">'
        + '<span class="gfeed-card__badge gfeed-card__badge--' + speedFor(p.tags) + '">' + badgeFor(p.tags) + '</span>'
        + '<button type="button" class="gfeed-card__heart' + (liked1 ? ' is-liked' : '') + '" data-handle="' + esc(p.handle) + '" aria-label="Save to wishlist">' + HEART + '</button>'
        + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '')
        + '</a>'
        + '<div class="gfeed-card__body">'
        + (cat ? '<span class="gfeed-card__cat">' + esc(cat) + '</span>' : '')
        + '<a class="gfeed-card__title" href="' + purl + '">' + esc(p.title) + '</a>'
        + '<div class="gfeed-card__foot">'
        + '<span class="gfeed-card__price">' + money(v.price) + '</span>'
        + '<button type="button" class="gfeed-card__bag" data-variant-id="' + v.id + '" aria-label="Add ' + esc(p.title) + ' to cart">' + BAG + '</button>'
        + '</div></div>';
      return el;
    }

    addToCart(bag) {
      var id = bag.getAttribute('data-variant-id');
      if (!id || bag.__busy) return;
      bag.__busy = true;
      bag.classList.add('is-loading');
      var self = this;
      fetch(this.base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          if (window.giftgoToast) window.giftgoToast();
          var icon = document.querySelector('#cart-icon-bubble');
          if (icon) { icon.classList.remove('giftgo-cart-shake'); void icon.offsetWidth; icon.classList.add('giftgo-cart-shake'); setTimeout(function () { icon.classList.remove('giftgo-cart-shake'); }, 700); }
          fetch(self.base + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
            document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (s) { s.textContent = c.item_count; });
            var bubble = document.querySelector('.cart-count-bubble');
            if (!bubble && c.item_count > 0) {
              var ic = document.querySelector('#cart-icon-bubble');
              if (ic) { var b = document.createElement('div'); b.className = 'cart-count-bubble'; b.innerHTML = '<span aria-hidden="true">' + c.item_count + '</span>'; ic.appendChild(b); }
            }
          });
          document.dispatchEvent(new CustomEvent('giftgo:added'));
        })
        .catch(function () {})
        .then(function () { bag.classList.remove('is-loading'); setTimeout(function () { bag.__busy = false; }, 800); });
    }

    toggleHeart(h) {
      var handle = h.getAttribute('data-handle');
      var a = wishlist();
      var i = a.indexOf(handle);
      if (i > -1) { a.splice(i, 1); h.classList.remove('is-liked'); }
      else { a.unshift(handle); h.classList.add('is-liked'); }
      saveWishlist(a);
    }
  }
  if (!customElements.get('giftgo-shopfeed')) customElements.define('giftgo-shopfeed', GiftgoShopfeed);
})();
